import { type SVGProps } from "react";

export const ClassScheduleLarge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={168}
    height={168}
    fill="none"
    viewBox="0 0 168 168"
    {...props}
  >
    <circle cx={83.901} cy={85.086} r={64} fill="#F1F5F9" transform="rotate(-.812 83.901 85.086)" />
    <path stroke="#535A68" strokeLinecap="round" strokeWidth={2.05} d="M45.1 58.913h14.862" />
    <rect
      width={102}
      height={111}
      x={32.5}
      y={29.5}
      fill="#fff"
      stroke="#000"
      strokeWidth={3}
      rx={6.5}
    />
    <rect width={14} height={48} x={43} y={75} fill="#F1F5F9" rx={2.148} />
    <rect width={13.962} height={5.817} x={43} y={84.56} fill="#64748B" rx={2} />
    <rect width={13.962} height={5.817} x={43} y={93.868} fill="#CBD5E1" rx={2} />
    <rect width={13.962} height={5.817} x={43} y={112.484} fill="#94A3B8" rx={2} />
    <rect width={14} height={48} x={60.06} y={75} fill="#F1F5F9" rx={2.148} />
    <rect width={13.962} height={5.817} x={60} y={93.868} fill="#64748B" rx={2} />
    <rect width={13.962} height={5.817} x={60} y={112.484} fill="#CBD5E1" rx={2} />
    <rect width={14} height={48} x={77.06} y={75} fill="#F1F5F9" rx={2.148} />
    <rect width={13.962} height={5.817} x={77.06} y={84.56} fill="#94A3B8" rx={2} />
    <rect width={13.962} height={5.817} x={77.06} y={93.868} fill="#CBD5E1" rx={2} />
    <rect width={13.962} height={5.817} x={77.06} y={112.484} fill="#94A3B8" rx={2} />
    <rect width={14} height={48} x={94.06} y={75} fill="#F1F5F9" rx={2.148} />
    <rect width={13.962} height={5.817} x={94.06} y={93.868} fill="#64748B" rx={2} />
    <rect width={13.962} height={5.817} x={94.06} y={112.484} fill="#64748B" rx={2} />
    <rect width={14} height={48} x={111.06} y={75} fill="#F1F5F9" rx={2.148} />
    <rect width={13.962} height={5.817} x={111.06} y={84.56} fill="#94A3B8" rx={2} />
    <rect width={13.962} height={5.817} x={111.06} y={93.868} fill="#CBD5E1" rx={2} />
    <rect width={13.962} height={5.817} x={111.06} y={103.176} fill="#94A3B8" rx={2} />
    <rect width={13.962} height={5.817} x={111.06} y={112.484} fill="#CBD5E1" rx={2} />
    <path
      stroke="#000"
      strokeLinecap="square"
      strokeWidth={2.05}
      d="M41 45h24.6M41 49.1h21.013M41 53.2h25.112M67 69h34.85"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M106.659 46.654a60.439 60.439 0 0 0-.491 6.347 48.617 48.617 0 0 1 8.231 4.41 48.626 48.626 0 0 1 8.232-4.41 60.439 60.439 0 0 0-.491-6.347m0 0a51.39 51.39 0 0 1 2.658-.814A59.884 59.884 0 0 0 114.399 40 59.889 59.889 0 0 0 104 45.841a50.548 50.548 0 0 1 10.399 4.155 50.741 50.741 0 0 1 7.741-3.342Zm-12.991 4.853a.748.748 0 0 0 .75-.75.749.749 0 0 0-1.28-.53.749.749 0 0 0 .53 1.28Zm0 0v-3.675a55.374 55.374 0 0 1 5.25-2.882m-7.007 11.55a5.989 5.989 0 0 0 1.757-4.243v-1.5"
    />
  </svg>
);
